HTMLImageElement.prototype.asyncLoad = function() {
  if (this.complete) {
    return Promise.resolve()
  }
  return new Promise(resolve => {
    const func = () => {
      resolve()
      this.removeEventListener("load", func)
    }
    this.addEventListener("load", func)
  })
}
